/**
 * Coverage map mapbox.js
 */


const eventMapEl = document.querySelector('.js-event-map')

if (eventMapEl) {

  const lat = Number(eventMapEl.dataset.lat);
  const lng = Number(eventMapEl.dataset.lng);

  document.addEventListener('DOMContentLoaded', function (event) {
    mapboxgl.accessToken = 'pk.eyJ1IjoicmFkaW9kbnMiLCJhIjoiY2tzMGl6ajJ6MG8zMDJ2cGp2dTh4OHp2MyJ9.ZU16X4Rn7nuDuQQkT0wljg'

    // Create map
    const map = new mapboxgl.Map({
      container: eventMapEl,
      style: 'mapbox://styles/radiodns/cks4jlim94ia217mv5exz9d1l',
      center: [lng, lat],
      zoom: 10,
    })

    // Create a default Marker and add it to the map.
    const marker = new mapboxgl.Marker({ color: '#fff', size: 'large' }).setLngLat([lng, lat]).addTo(map)

  })
}